import {
  createPropController
} from "../prop-controllers/instances";
import { PropController } from "../prop-controllers/base";
import {
  getTranslatableData,
  mergeTranslatedData
} from "./control";
import { copy as controlCopy } from "./control";
import {
  getElementChildren,
  getFileIds,
  getPageIds,
  getSwatchIds,
  getTypographyIds
} from "../prop-controllers/introspection";
const ShapeControlType = "makeswift::controls::shape";
function Shape(config) {
  return { type: ShapeControlType, config };
}
const ShapeControlMessageType = {
  SHAPE_CONTROL_CHILD_CONTROL_MESSAGE: "makeswift::controls::shape::message::child-control-message"
};
class ShapeControl extends PropController {
  controls;
  descriptor;
  send;
  constructor(send, descriptor) {
    super(send);
    this.descriptor = descriptor;
    this.send = send;
    this.controls = /* @__PURE__ */ new Map();
    this.setControls();
  }
  setControls = () => {
    const controls = /* @__PURE__ */ new Map();
    const children = this.descriptor.config.type;
    Object.keys(children).forEach((key) => {
      const control = createPropController(
        children[key],
        (message) => this.send({
          type: ShapeControlMessageType.SHAPE_CONTROL_CHILD_CONTROL_MESSAGE,
          payload: { message, key }
        })
      );
      controls.set(key, control);
    });
    this.controls = controls;
    return this.controls;
  };
  recv = (message) => {
    switch (message.type) {
      case ShapeControlMessageType.SHAPE_CONTROL_CHILD_CONTROL_MESSAGE: {
        const control = this.controls.get(message.payload.key);
        if (control == null)
          return;
        const recv = control.recv;
        recv(message.payload.message);
      }
    }
  };
}
function copyShapeData(definition, value, context) {
  if (value == null)
    return value;
  const newValue = {};
  for (const [key, itemDefinition] of Object.entries(definition.config.type)) {
    const prop = value[key];
    newValue[key] = controlCopy(itemDefinition, prop, context);
  }
  return newValue;
}
function introspectShapeData(definition, value, func) {
  if (value == null)
    return [];
  return Object.entries(definition.config.type).flatMap(
    ([key, definition2]) => func(definition2, value[key])
  );
}
function getShapeElementChildren(definition, data) {
  return introspectShapeData(definition, data, getElementChildren);
}
function getShapeSwatchIds(definition, data) {
  return introspectShapeData(definition, data, getSwatchIds);
}
function getShapeTypographyIds(definition, data) {
  return introspectShapeData(definition, data, getTypographyIds);
}
function getShapePageIds(definition, data) {
  return introspectShapeData(definition, data, getPageIds);
}
function getShapeFileIds(definition, data) {
  return introspectShapeData(definition, data, getFileIds);
}
function getShapeTranslatableData(definition, data) {
  return Object.fromEntries(
    Object.entries(definition.config.type).map(([key, definition2]) => [
      key,
      getTranslatableData(definition2, data[key])
    ])
  );
}
function mergeShapeTranslatedData(definition, data, translatedData, context) {
  return Object.fromEntries(
    Object.entries(definition.config.type).map(([key, definition2]) => [
      key,
      mergeTranslatedData(definition2, data[key], translatedData[key], context)
    ])
  );
}
export {
  Shape,
  ShapeControl,
  ShapeControlMessageType,
  ShapeControlType,
  copyShapeData,
  getShapeElementChildren,
  getShapeFileIds,
  getShapePageIds,
  getShapeSwatchIds,
  getShapeTranslatableData,
  getShapeTypographyIds,
  mergeShapeTranslatedData
};
//# sourceMappingURL=shape.js.map